import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../lots/WeightLots.css';

const WeightAnimalsCard = ({ row, latestWeights, weighInCounts, fmtLotCode }) => {
  const { t }    = useTranslation();
  const navigate = useNavigate();
  const latest   = latestWeights[row.tag];
  const count    = weighInCounts[row.tag] || 0;

  return (
    <div className="wl-card" onClick={() => navigate(`/weight/animals/${row.tag}`)}>
      <div className="wl-card-main">
        <div className="wl-card-code">{t('tag')} #{row.tag}</div>
        <div className="wl-card-chevron">›</div>
        <div className="wl-card-name">
          {row.lot_id && <span style={{ color: '#5d8a3a', fontWeight: 500 }}>{fmtLotCode(row.lot_id)}</span>}
          {latest && <span style={{ color: '#555', marginLeft: row.lot_id ? 8 : 0 }}>· {latest.weight} kg</span>}
          {count > 0 && <span style={{ marginLeft: 8, color: '#aaa' }}>({count} {t('total_weigh_ins').toLowerCase()})</span>}
        </div>
      </div>
    </div>
  );
};

const WeightAnimalsCardList = ({ data, latestWeights = {}, weighInCounts = {}, fmtLotCode }) => {
  return (
    <div className="wl-card-list">
      {(data || []).map(row => (
        <WeightAnimalsCard
          key={row._id}
          row={row}
          latestWeights={latestWeights}
          weighInCounts={weighInCounts}
          fmtLotCode={fmtLotCode}
        />
      ))}
      {(!data || data.length === 0) && (
        <div className="wl-card-empty">—</div>
      )}
    </div>
  );
};

export default WeightAnimalsCardList;
